import Api from '@/api/api'

export default {
    getVendors(id) {
        return Api.get('Vendor/Vendor/GetVendors?facilityID=' + id)
    },
    getVendorById(id) {
        return Api.get('Vendor/Vendor/GetVendorById/' + id)
    },
    addVendor(data) {
        return Api.post('Vendor/Vendor/AddVendor', data)
    },
    updateVendor(id, data) {
        return Api.put('Vendor/Vendor/UpdateVendor/' + id, data)
    },
    deleteVendor(id) {
        return Api.delete('Vendor/Vendor/DeleteVendor/' + id)
    },
    getUnassignedVendor(id) {
        return Api.get('Vendor/Vendor/GetUnassignedVendors?facilityID=' + id)
    },
    addUnassignedVendor(id, data) {
        return Api.post('Vendor/Vendor/AddUnassignedVendors?vendorUniqueID=' + id, data)

    },
    getColumn() {
        return Api.get('Org/api/Settings/ExplicitColumns?actor=Vendor')
    },

}